import React,{useState,useEffect,useCallback,useRef} from "react";
import close from "../../assets/svg/close-1.svg";
import user from "../../assets/svg/users.svg";
import location from "../../assets/svg/location-red.svg";
import checked from "../../assets/svg/checked.svg";
import upload from "../../assets/svg/upload-img.svg";
import { getReferenceApi } from "../asset-list/asset-api";
import failed from "../../assets/svg/close-chip.svg";
import download from "../../assets/svg/download-file.svg";
const ReferenceViewModal = ({referenceId,onCancel}) => {
const [referenceData, setReferenceData] = useState({});
     useEffect(() => {      
         getReference();       
     }, [referenceId]);
   const getReference = async () => {    
         const response = await getReferenceApi(referenceId);
         if (response.data.success === true) {
          setReferenceData(response.data.transaction??{})
         }
       }

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#F0F4F9",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "815px",
      overflowY: "auto",
      padding:'24px'
    },
    card:{
      width: '370.5px',
      height: '104px',
      borderRadius: '16px',
      padding: '16px',
      background:'#FFFFFF',
      border: '1px solid #EBEBEB'
    }, title:{
      fontSize:'12px',
      fontWeight:'600',
      color:'#8790A1'
    }
  };

  const downloadFile = (url) => {
  const link = document.createElement('a');
  link.href = url;
  /* link.download = filename || ''; */
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
return (<div style={modalStyle.overlay}>
    <div style={modalStyle.modal}>
      <div style={{background:'#F0F4F9'}}>
   <div className="style-justify-between">
      <div>{referenceData.date??''}</div>
      <div><img src={close} alt="close" onClick={onCancel} width={'36px'} height={'36px'} /></div>
   </div>
   <div className="style-justify-between mt-2" style={{flexWrap:'wrap', gap:'16px'}}>
      <div style={modalStyle.card}>
         <div style={modalStyle.title}>CREATED BY</div>
         <div className="mt-1 style-justify-start">
            <div style={{width:'44px', height:'44px', borderRadius:'100px',background:'#F0F4F9'}}>
          <img src={user} alt="USER" style={{width:'44px', height:'44px', borderRadius:'100px'}} />
          </div>
          <div className="ms-2 ">
           <div style={{fontSize:'14px', fontWeight:'500',color:'#172B4D'}}>{referenceData.checker??''}</div> 
           <div className="style-justify-start mt-1"><img src={location} alt="close"/> <span className="ms-2" style={{fontSize:'13px', fontWeight:'400', color:'#172B4D'}}>{referenceData.location??''}</span> </div>
          </div>
         </div>
      </div>
      <div style={modalStyle.card}>
         <div style={modalStyle.title}>USED BY</div>
         <div className="mt-1 style-justify-start">
            <div style={{width:'44px', height:'44px', borderRadius:'100px',background:'#F0F4F9'}}>
          <img src={user} alt="USER" style={{width:'44px', height:'44px', borderRadius:'100px'}} />
          </div>
          <div className="ms-2 ">
           <div style={{fontSize:'14px', fontWeight:'500',color:'#172B4D'}}>{referenceData.emp_name??''}</div> 
           <div className="style-justify-start mt-1"><span className="ms-2" style={{fontSize:'13px', fontWeight:'400', color:'#172B4D'}}>{referenceData.emp_id??''}</span> </div>
          </div>
         </div>
      </div>
   </div>
   <div className="mt-2" style={{width:'100%', background:'#FFFFFF', borderRadius:'16px', padding:'16px',}}>
       <div className="style-justify-between " style={{flexWrap:'wrap',}}>
         <div style={{fontSize:'18px', fontWeight:'600', color:'#172B4D'}}>Reference : {referenceData?.references?.length??'0'}</div>
        <div className="px-2 py-2 style-justify-center" style={{height:'36px', borderRadius:'100px', background:referenceData.check_status===true?'#E0FFE8':'#FFE8E8'}}>
                {referenceData.check_status===true && (<img src={checked} alt="Checked" />)} {referenceData.check_status===false && (<img src={failed} alt="Failed" />)} <span className="ms-2 font-14-400-172B4D">{referenceData.check_status===true?'TRUE':'FALSE'}</span>
            </div>
       </div>

       <div className="mt-2">
         {referenceData.references?.map((ref, i) => (<div className="style-justify-between " style={{width:'100%', height:'88px', background:'#F8F8F8', padding:'12px', border:'0.6px solid #EBEBEB', borderRadius:'16px'}}><div className="style-justify-start " >
           <img src={upload} alt="Asset"  style={{width:'64px', height:'64px', borderRadius:'8px', border:'1px solid #EBEBEB'}}/> 
           <div className="ms-2 ">
           <div style={{fontSize:'16px', fontWeight:'400',color:'#172B4D'}}>{ref.ref_no??'---'}</div> 
           <div className="style-justify-start mt-1"><span  style={{fontSize:'14px', fontWeight:'400', color:'#8790A1'}}>Qty :</span> 
            <span className="ms-2" style={{fontSize:'14px', fontWeight:'500', color:'#3B84E6'}}>{ref.qty??'0'}</span> </div>
          </div>
          
         </div>
        {ref.file_path!==null && ref.file_path!=="" &&( <img src={download} onClick={()=>{downloadFile(ref.file_path)}} alt="download"   className="cursor-pointer" width={'30px'} height={'30px'} />)}
         </div>))}

       </div>
   </div>
   </div>
</div>
</div>)
}
export default ReferenceViewModal;